/**
 * Get operator name and email
 * @param {object} payload
 * @param {string} payload.email
 * @param {string} [payload.name]
 * @param {string} [payload.surname]
 *
 * @returns {string}
 */
export const getOperatorNameAndEmail = (payload) => {
  const { name, surname, email } = payload

  let text = `${name || ''} ${surname || ''}`.trim()
  if (!text) return email

  text += ` (${email})`

  return text
}


/**
 * Get operator name or email
 * @param {object} payload
 * @param {string} payload.email
 * @param {string} [payload.name]
 * @param {string} [payload.surname]
 *
 * @returns {string}
 */
export const getOperatorNameOrEmail = (payload) => {
  const { name, surname, email } = payload
  let text = `${name || ''} ${surname || ''}`.trim()
  if (!text) return email
  return text
}